import React from 'react';
import moment from 'moment';

export function DateColumnFormatter(date: any, showTime = false) {
  return (
    <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap">
      <div>
        {date ? moment(date).format('DD-MM-YYYY') : ''}
      </div>
      {showTime &&
        <div className="text-muted">
          {date ? moment(date).format('HH:mm:ss') : ''}
        </div>
      }
    </div>
  );
}
